module.exports = __webpack_public_path__ + "static/media/1.accd14c3.jpg";